import React from 'react';
import { createPortal } from 'react-dom';
import './Toast.css';

function ToastItem({ id, message, type, onDismiss }) {
  return (
    <div
      className={'toast toast--' + type}
      role="alert"
      aria-live="polite"
    >
      <span className="toast-message">{message}</span>
      <button
        type="button"
        className="toast-dismiss"
        aria-label="Dismiss"
        onClick={function () { onDismiss(id); }}
      >
        ×
      </button>
    </div>
  );
}

function Toast({ toasts, removeToast }) {
  if (!toasts.length) return null;

  const content = (
    <div className="toast-container" aria-label="Notifications">
      {toasts.map(function (t) {
        return (
          <ToastItem
            key={t.id}
            id={t.id}
            message={t.message}
            type={t.type}
            onDismiss={removeToast}
          />
        );
      })}
    </div>
  );

  return createPortal(content, document.body);
}

export default Toast;
